import { Link } from "react-router-dom";
import { formatFavorites, type Manga } from "@/mocks/manga";

export default function MangaCard({ manga }: { manga: Manga }) {
  return (
    <Link
      to={`/manga/${manga.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all duration-200 hover:-translate-y-1 hover:border-primary-300"
      data-product-shop
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-background-100">
        <img
          src={manga.cover}
          alt={`${manga.title} 封面，${manga.categoryName}类萌系漫画`}
          title={`${manga.title} - 喵趣漫画网`}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-bold text-background-50 ${
            manga.status === "连载中" ? "bg-secondary-500" : "bg-foreground-600"
          }`}
        >
          {manga.status}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-bold text-primary-700 backdrop-blur">
          <i className="ri-star-fill mr-1 text-accent-500" aria-hidden="true"></i>
          {manga.rating.toFixed(1)}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 md:text-base">
          {manga.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600 md:text-sm">
          {manga.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {manga.tags.slice(0, 2).map((t) => (
            <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
              {t}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-bookmark-line text-primary-600" aria-hidden="true"></i>
            {formatFavorites(manga.favorites)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-play-list-line text-secondary-700" aria-hidden="true"></i>
            {manga.chapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}